import {createSlice} from '@reduxjs/toolkit';
import {permissionsInitialState} from './permissions.initialState';
import {permissionsReducer as reducers} from './permissions.reducer';
import {permissionsExtraReducer} from './permissionsExtra.reducer';

export const permissionsSlice = createSlice({
  name: 'permissions',
  initialState: permissionsInitialState,
  reducers,
  extraReducers: permissionsExtraReducer,
});

export const {setLoading} = permissionsSlice.actions;
export const {actions: permissionsActions, reducer: permissionsReducer} = permissionsSlice;
